import { CarouselProvider, DotGroup, Slide, Slider } from "pure-react-carousel";
import 'pure-react-carousel/dist/react-carousel.es.css';
import React from "react";

export default class ImageCarousel extends React.Component
{ 
    render() 
    {
        const heights =
        {
            "16:9": "aspect-[16/9]",
            "4:3": "aspect-[4/2]",
            "3:2": "aspect-[3/2]",
        }

        if(this.props.block.images.length < 1) return <></>;
   
        return (
            <section>
                <div className ="shell">
                    <div className="is-a-slider boxes boxes--secondary mb-8">
                        <CarouselProvider
                            totalSlides={this.props.block.images.length}
                            visibleSlides={1}
                            isIntrinsicHeight={true}
                            interval={5000}
                            isPlaying={true}
                        >
                            <Slider
                                role="region"
                                aria-label="Image Carousel"
                            >
                                {this.props.block.images.map((image, i) => (
                                    <figure
                                        key={i}
                                        className={"relative item w-full " + (this.props.block.aspectRatio ? heights[this.props.block.aspectRatio] : "aspect-[16/9]") }
                                    >
                                        <img
                                            src={"https://cms.genesis-analytics.com" + image.url}
                                            alt={image.imageAlt}
                                            className="absolute inset-0 w-full h-full object-cover"
                                        />
                                        {image.caption && (
                                            <figcaption className="carousel-caption">
                                                {image.caption}
                                            </figcaption>
                                        )}
                                    </figure>
                                ))}
                            </Slider>
                            <DotGroup className="text-center mt-4" />
                        </CarouselProvider>
                    </div>
                </div>
            </section>
        );
    }
}
